
  /**
   * Entry point for running the application.
   * Must export an object with a start() method.
   *
   * Since this is a feature, the entry point is only used for running it in isolation.
   * When consumed by a page, the entry point will be defined by the consumer.
   */
import $ from 'jquery';
import Backbone from 'backbone';
import Marionette from 'backbone.marionette';
import '@core/vendor/radio.shim'; // shim app.channel
import Example from './src/sitelet-automation';
import pkg from './package.json';
import ObjectUtil from '@component/common/src/util/ObjectUtil';

/* eslint-disable-next-line no-unused-vars,no-global-assign,no-undef,camelcase */
__webpack_public_path__ = `${pkg.version}/`;

const PageApp = new Marionette.Application();


// PageApp.setMeta = () => {
//     try {
//       PageApp.meta = JSON.parse($('script[data-bootstrap="page/home-page"]').html()).meta || {};
//     } catch (e) {
//       PageApp.meta = {};
//     }
// };


PageApp.on('start', () => {
  // if (Backbone.history) {
    PageApp.Feature = new Example();

      PageApp.Feature.init();

    const mainObject = $('#main');
    //if (mainObject.length > 0) {
    //}
  // }
});

export default PageApp;




// WEBPACK FOOTER //
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_imp/package/app.js